import React from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';

import isLocalLink from '@web-packages/library/helpers/isLocalLink';
import { types as customTextTypes } from '../CustomText';
import { helper, types, iconTypes } from './types';

import { LinkLabel, IconWrapperLeft, IconWrapperRight } from './styled';
import variants from './variants';

const { showLeft, showRight } = helper;

const Textlink = React.forwardRef((props, ref) => {
  const {
    type,
    variant,
    name,

    iconType,
    url,
    linkText,
    showUnderline,
    rel,

    disableAllStates,
    stateType,
    className,
    customTextType,
  } = props;

  const LeftIcon = iconType?.left;
  const RightIcon = iconType?.right;

  return (
    <LinkLabel
      variant={variant}
      href={url}
      type={type}
      customTextType={customTextType}
      iconType={iconType}
      htmlFor={name}
      showUnderline={showUnderline}
      className={`${className} ${stateType}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      ref={ref}
      rel={rel}
      disableAllStates={disableAllStates}
    >
      {(showLeft(type) && LeftIcon) && (
        <IconWrapperLeft className="icon-wrapper">
          <LeftIcon tabIndex="-1" />
        </IconWrapperLeft>
      )}
      {linkText}
      {(showRight(type) && RightIcon) && (
        <IconWrapperRight className="icon-wrapper">
          <RightIcon tabIndex="-1" />
        </IconWrapperRight>
      )}
    </LinkLabel>
  );
});

Textlink.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  variant: PropTypes.oneOf(Object.values(variants)),
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  iconType: PropTypes.any,
  url: PropTypes.string,
  linkText: PropTypes.string.isRequired,
  className: PropTypes.string,
  showUnderline: PropTypes.bool,
  rel: PropTypes.string,
  disableAllStates: PropTypes.bool,
  stateType: PropTypes.string,
  customTextType: PropTypes.oneOf(Object.values(customTextTypes)),
};
Textlink.defaultProps = {
  type: types.none,
  variant: variants.primary,
  className: '',
  iconType: iconTypes.arrow,
  showUnderline: true,
  rel: undefined,
  disableAllStates: false,
  stateType: '',
  url: null,
  customTextType: null,
};

const isTelOrMailTag = (_url) => _url?.startsWith('mailto') || _url?.startsWith('tel');

// eslint-disable-next-line react/prop-types
const TextlinkWrapper = ({ url, ...rest }) => {
  const isLocal = isLocalLink(url);
  const isTelOrMailLink = isTelOrMailTag(url);

  const CustomTextlink = (
    <Textlink
      url={url}
    // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      target={(isLocal || isTelOrMailLink) ? undefined : '_blank'}
      rel={(isLocal || isTelOrMailLink) ? undefined : 'noopener noreferrer'}
    />
  );

  if (isLocal) {
    return (
      <NextLink href={url} passHref locale={false} legacyBehavior>
        {CustomTextlink}
      </NextLink>
    );
  }

  return CustomTextlink;
};

export default TextlinkWrapper;
